import type {
  DateTimeType,
  DateTimeValue
} from '@elfsight/configurator-contracts';
import { getDateTimeValueByDate } from './get-date-time-value-by-date';

export function createDateTimeValue<T extends DateTimeType>(
  givenDate: Date,
  type: T
): DateTimeValue<T> {
  const { date, time } = getDateTimeValueByDate(givenDate);

  return {
    datetime: {
      type: 'datetime',
      date,
      time
    },
    date: {
      type: 'date',
      date
    },
    time: {
      type: 'time',
      time
    }
  }[type] as DateTimeValue<T>;
}
